const DOMAIN_MAP = {
  "freitag-bs.de": "gruppe",
  "sachverstaendiger-freitag-bs.de": "sachverstaendiger",
  "galabau-freitag.de": "galabau",
  "bauunternehmung-freitag.de": "bauunternehmung",
};

const SITE_CONFIG = {
  gruppe: {
    id: "gruppe",
    name: "Freitag-Gruppe",
    companyArea: "Freitag Gruppe",
    domain: "freitag-bs.de",
    title: "Freitag-Gruppe Braunschweig | Bauunternehmung, Galabau & Sachverständiger",
    description: "Die Freitag-Gruppe aus Braunschweig vereint Bausanierung, Tiefbau, Garten- und Landschaftsbau sowie Sachverständigenbüro unter einem Dach. Über 25 Jahre Erfahrung. 4.9 Sterne auf Google.",
    canonical: "https://www.freitag-bs.de",
  },
  sachverstaendiger: {
    id: "sachverstaendiger",
    name: "Sachverständiger Freitag",
    companyArea: "Sachverständiger Freitag",
    domain: "sachverstaendiger-freitag-bs.de",
    title: "Sachverständiger Braunschweig | Gutachten, Dichtheitsprüfung & Generalinspektion | Freitag",
    description: "Sachverständigenbüro Freitag in Braunschweig: Immobiliengutachten, Bauschadenbewertung, Wertermittlung, Dichtheitsprüfung, Generalinspektion Abscheider nach DIN EN 1610 & DIN 1986-30.",
    canonical: "https://www.sachverstaendiger-freitag-bs.de",
  },
  galabau: {
    id: "galabau",
    name: "Galabau Freitag",
    companyArea: "Galabau Freitag",
    domain: "galabau-freitag.de",
    title: "Galabau Braunschweig | Gartengestaltung, Pflasterarbeiten & Grünpflege | Freitag",
    description: "Freitag Galabau in Braunschweig: Professionelle Gartengestaltung, Pflasterarbeiten, Bepflanzung und Grünflächenpflege. Über 15 Jahre Erfahrung im Garten- und Landschaftsbau.",
    canonical: "https://www.galabau-freitag.de",
  },
  bauunternehmung: {
    id: "bauunternehmung",
    name: "Bauunternehmung Freitag",
    companyArea: "Bauunternehmung Freitag",
    domain: "bauunternehmung-freitag.de",
    title: "Bauunternehmung Braunschweig | Bausanierung, Tiefbau & Pflasterarbeiten | Freitag",
    description: "Bauunternehmung Freitag GmbH in Braunschweig: Bausanierung, Kellerabdichtungen, Kellersanierungen, Tiefbau und Pflasterarbeiten. Über 25 Jahre Erfahrung. 4.9 Sterne auf Google.",
    canonical: "https://www.bauunternehmung-freitag.de",
  },
};

export function getCurrentSite() {
  const hostname = window.location.hostname.replace("www.", "").toLowerCase();
  const siteKey = DOMAIN_MAP[hostname] || "gruppe";
  return SITE_CONFIG[siteKey];
}

export function getSiteConfig(key) {
  return SITE_CONFIG[key] || SITE_CONFIG.gruppe;
}

export { SITE_CONFIG, DOMAIN_MAP };
